module.exports = __webpack_public_path__ + "static/media/postcard-placeholder.1ae7bf61.jpg";